(function (ws) {
    'use strict';
    ws.views.ManualcompRMATable = ws.views.staticTable.extend({
        el: '#returnManualRMAForm',
        events: {
            'click .rma-serial-number-modal': 'openSerialNumberModal'
        },

        /**
         * initialize override
         */
        initialize: function () {
            this.$table = this.$('#rfq-table-reseller');
            this.responsivePriority = [
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2}
            ];
            ws.views.staticTable.prototype.initialize.call(this);
        },

        /**
         * Trigger serial number modal, passing oderCode and entryNumber parameters.
         * {Object} ev - Event object
         */
        openSerialNumberModal: function (ev) {
            ev.preventDefault();
            var $el = $(ev.currentTarget);

            new ws.views.rmaSerialNumbers({
                orderCode: $el.data('orderCode'),
                entryNumber: $el.data('entryNumber'),
                selectedSerialNumbers: $el.siblings('.selectedCheckbox').val(),
                el: $('#rma-SerialNumbersModal')
            });
        }
    });
})(westcon);
